var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 13 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-2747 -22823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 50,
    height: 50,
    transform: "translate(2747 22823)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M17.495,0h-15A2.507,2.507,0,0,0,0,2.521V21.479A2.507,2.507,0,0,0,2.495,24H17.505A2.507,2.507,0,0,0,20,21.479V2.521A2.507,2.507,0,0,0,17.505,0Zm-6.97,18.433H4.593a.633.633,0,0,1,0-1.266h5.931a.633.633,0,0,1,0,1.266ZM15.4,14.44H4.593a.633.633,0,0,1,0-1.266H15.4a.633.633,0,0,1,0,1.266Zm0-4H4.593a.633.633,0,0,1,0-1.266H15.4a.633.633,0,0,1,0,1.266Zm0-4H4.593a.633.633,0,0,1,0-1.266H15.4a.633.633,0,0,1,0,1.266Z",
    transform: "translate(2762 22836)",
    fill: "#46324e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf13);
export default __webpack_public_path__ + "static/media/icon-wf-13.d85764f5ef8d11e2c30337d01ab2c90f.svg";
export { ForwardRef as ReactComponent };